require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-y-df-0-m.json") })
        }
      }, "path---photos-professional-y-df-0-m");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-y-df-0-m!./.cache/json/photos-professional-y-df-0-m.json
// module id = 952
// module chunks = 231608221292675